module.exports = __webpack_public_path__ + "src/assets/img/historie_special_de.0b9f6955.png";